import LoadToken from './LoadToken';

export default LoadToken;
